// import createSagaMiddleware from 'redux-saga'
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { reduxBatch } from '@manaflair/redux-batch';
import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import { persistStore } from 'redux-persist';
import { persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import {
  authSlice,
  campaingsSlice,
  bulkOptionExcelDownloadSlice,
  userInfoContactSlice,
  userInfoAddressSlice,
  userInfoCompanySlice,
  userInfoTokenSlice,
  catalogSearchSlice,
  productReviewsSlice,
  productQuestionsSlice,
  documentSlice,
  productPoolSlice,
  categoryListSlice,
  brandListSlice,
  inventoryExportSlice,
  inventoryListSlice,
  userListSlice,
  exportPoolSlice,
  exportListSlice,
  announcementSlice,
  completedTicketSlice,
  ticketSlice,
  dataTableSlice,
  templateSlice,
  vendorSharedOffersSlice,
} from 'src/services/redux/slices';
import maintenanceSlice from '../slices/maintenance/maintenance.slice';

const persistConfig = {
  key: 'root',
  version: 1,
  storage,
  // blacklist: [
  //   'excelDownload',
  //   'campaigns',
  //   'contacts',
  //   'catalogSearch',
  //   'document',
  //   'productPool',
  //   'vendorCategories',
  //   'vendorBrands',
  //   'productQuestions',
  //   'productReviews',
  //   'inventoryList',
  //   'inventoryExport',
  //   'token',
  //   'address',
  //   'company',
  // ],
  whitelist: ['auth', 'document', 'company', 'token', 'address', 'contacts'],
  blacklist: ['exportPool', 'catalogSearch', 'dataTable'],
};

const rootReducer = combineReducers({
  auth: authSlice,
  campaigns: campaingsSlice,
  excelDownload: bulkOptionExcelDownloadSlice,
  contacts: userInfoContactSlice,
  address: userInfoAddressSlice,
  company: userInfoCompanySlice,
  token: userInfoTokenSlice,
  catalogSearch: catalogSearchSlice,
  productReviews: productReviewsSlice,
  productQuestions: productQuestionsSlice,
  document: documentSlice,
  productPool: productPoolSlice,
  vendorBrands: brandListSlice,
  vendorCategories: categoryListSlice,
  inventoryList: inventoryListSlice,
  inventoryExport: inventoryExportSlice,
  userList: userListSlice,
  exportPool: exportPoolSlice,
  exportList: exportListSlice,
  announcementList: announcementSlice,
  ticketList: ticketSlice,
  completedTicket: completedTicketSlice,
  maintenanceList: maintenanceSlice,
  dataTable: dataTableSlice,
  template:templateSlice,
  vendorSharedOffers: vendorSharedOffersSlice,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== 'production',
  enhancers: [reduxBatch],
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
/**
 * @see https://github.com/rt2zz/redux-persist#persiststorestore-config-callback
 * @see https://github.com/rt2zz/redux-persist#persistor-object
 */
export const persistor = persistStore(store);

// sagaMiddleware.run(rootSaga)

export default store;
